import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import Box from "ds/components/Box";
import Badge from "ds/components/Badge";
import TableCellText from "ds/components/Table/Row/CellText";
import TableCellLink from "ds/components/Table/Row/CellLink";
import useTypedContext from "hooks/useTypedContext";
import { FlowsProjectRoleBindingView } from "shared/Flows/Projects/useFlowsProject/types";
import { SpacesContext } from "views/Account/SpacesProvider";
import { AnalyticsPageFlows } from "hooks/useAnalytics/pages/flows";

const FlowsProjectDetailsRolesNameCell = ({
  item: roleBinding,
  ...cellProps
}: TableSimpleCellProps<FlowsProjectRoleBindingView>) => {
  const { hasManageableSpaces } = useTypedContext(SpacesContext);

  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <Box align="center" fullWidth gap="large">
        {hasManageableSpaces ? (
          <TableCellLink
            href={`/settings/role/${roleBinding.role.id}`}
            target="_blank"
            analyticsPage={AnalyticsPageFlows.FlowsProjectRoles}
            analyticsTitle="Navigated to role settings"
          >
            {roleBinding.role.name}
          </TableCellLink>
        ) : (
          <TableCellText>{roleBinding.role.name}</TableCellText>
        )}

        {roleBinding.role.isSystem && <Badge type="strong" variant="blue" text="SYSTEM" />}
      </Box>
    </TableSimpleCell>
  );
};

export default FlowsProjectDetailsRolesNameCell;
